import React, { useEffect, useState } from 'react'
import Charts from 'react-apexcharts'
import { useStateWithCallback } from '../../utils/hooks/useStateWithCallback'

type Props = {
  className: string
  overviewTotal: any[]
}

interface ApexChartsvalue {
  options: {
    labels: string[]
    dataLabels: {
      enabled: boolean
    }
    tooltip: {
      enabled: boolean
    }
    title: {
      style: {
        fontSize: string
        position: string
      }
    }
    colors: string[]
    legend: {}
  }
  series: number[]
}

const PieChart: React.FC<Props> = ({ className, overviewTotal }) => {
  const values: ApexChartsvalue = {
    options: {
      labels: ['Assigned', 'Unassigned'],
      dataLabels: {
        enabled: true
      },
      tooltip: {
        enabled: true
      },
      title: {
        style: {
          fontSize: '400px',
          position: 'bottom'
        }
      },
      colors: ['#09cf6a', '#F6A40A'],
      legend: {
        show: false,
        position: 'bottom',
        fontSize: '17px'
      }
    },
    series: [24, 2]
  }

  const [state, setState] = useStateWithCallback<ApexChartsvalue>(values)
  const [isData, setIsData] = useState(true)

  useEffect(() => {
    // if (!!botAnalyticsFilterInput) {
    const pieChartData: number[] = overviewTotal
    const isAllZero = pieChartData.every((item) => item === 0)
    setIsData(isAllZero)

    if (!isAllZero) {
      setState((prevState) => ({
        ...prevState,
        options: {
          ...prevState.options
        },
        series: pieChartData
      }))
    } else {
      setState((prevState) => ({
        ...prevState,
        options: {
          labels: ['No Data Available'],
          dataLabels: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          title: {
            style: {
              fontSize: '400px',
              position: 'bottom'
            }
          },
          colors: ['#808080'],
          legend: {
            show: false,
            position: 'bottom',
            fontSize: '17px'
          }
        },
        series: [1]
      }))
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overviewTotal])

  return (
    <div className={`card ${className}`}>
      <div className='card-body d-flex flex-column p-10 align-self-center'>
        <div className='d-flex flex-column flex-grow-1 py-2 py-lg-13 me-2'>
          <p className='fw-bolder text-dark fs-4 fs-md-6 mb-3 text-hover-primary align-self-center'>
            Conversation Status Overview
          </p>

          <Charts options={state.options} series={state.series} type='donut' width='340' />
        </div>

        <div className='align-self-center '>
          <ul className=' list-group  '>
            {isData ? (
              <h3>No Data Available</h3>
            ) : (
              <div>
                {/* <li className='align-items-center fs-5'>
                  Resolved &nbsp;
                  <span className='text-primary'>
                    ({overviewTotal[0] || 0})
                  </span>
                </li> */}
                <li className='align-items-center fs-5'>
                  Assigned &nbsp; <span className='text-primary'>({overviewTotal[0] || 0})</span>
                </li>
                <li className='align-items-center fs-5'>
                  Unassigned &nbsp; <span className='text-primary'>({overviewTotal[1] || 0})</span>
                </li>
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default PieChart
